<template>
  <v-dialog :value="dialog" max-width="550" @click:outside="close" @keydown.esc="close">
    <v-card v-if="payslip">
      <v-form v-on:submit.prevent="assign">
        <v-card-title>
          <span class="headline">Asignar legajo</span>
        </v-card-title>

        <v-card-text>
          <p class="mb-1">
            Recibo <b>{{ payslip.file_name }}</b>
          </p>
          <p class="mb-5">
            CUIL leído del PDF: <b>{{ payslip.extracted_cuil || "no se encontró" }}</b>
          </p>

          <v-autocomplete v-model="legajo" :items="legajos" :item-text="legajoText" item-value="id" return-object
            label="Legajo*" name="legajo" data-vv-as="legajo" v-validate="'required'" :loading="loading_legajos"></v-autocomplete>
          <span class="red--text">{{ errors.first("legajo") }}</span>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="primary" :disabled="loading" @click="$emit('preview', payslip)">Ver recibo</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" text :disabled="loading" @click="close">Cancelar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Asignar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { payslipService } from "@/libs/ws/payslipService";
import { legajoService } from "@/libs/ws/legajoService";
import { legajoLabel } from "@/constants/payslips";

export default {
  props: {
    dialog: Boolean,
    payslip: Object,
  },
  data() {
    return {
      legajo: null,
      legajos: [],
      loading: false,
      loading_legajos: false,
    };
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.$validator.reset();
      if (this.legajos.length == 0) this.loadLegajos();
      else this.selectCurrent();
    },
  },
  methods: {
    legajoText(legajo) {
      return legajoLabel(legajo) + (legajo.cuil ? " (" + legajo.cuil + ")" : "");
    },
    selectCurrent() {
      this.legajo = this.payslip.legajo ? this.legajos.find((l) => l.id == this.payslip.legajo.id) || null : null;
    },
    loadLegajos() {
      this.legajo = null;
      this.loading_legajos = true;
      legajoService
        .filter({ status: "all" })
        .then((response) => {
          if (response.status) this.legajos = response.result;
          this.selectCurrent();
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_legajos = false));
    },
    close() {
      this.$emit("updateDialog", false);
    },
    async assign() {
      if (this.loading || !(await this.$validator.validate())) return;

      this.loading = true;
      payslipService
        .assign({ id: this.payslip.id, legajo_id: this.legajo.id })
        .then((response) => {
          if (response.status) {
            this.$toast.success(response.msg, "OK");
            this.close();
            this.$emit("saved");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrió un error al asignar el recibo.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
